import React, {FC, ReactElement, useEffect, useState} from 'react';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import MicIcon from '@mui/icons-material/Mic';
import {Autocomplete, TextField} from '@mui/material';
import {setInitialOutputDevicesAmount} from '../reducers/sessionReducer';
import {useAppDispatch, useAppSelector} from '../hooks/storeHooks';
import cn from 'classnames'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {getDevices} from '../contexts/SessionContext';


const DeviceSelector: FC<DeviceSelectorProps> = ({
                                                     onDeviceSelected,
                                                     kind,
                                                     onlyTextEnabled = false,
                                                     id
                                                 }): ReactElement => {

    let sessionStarted = useAppSelector((state) => state.session.sessionStarted);
    let input = useAppSelector((state) => state.session.input);
    let outputs = useAppSelector((state) => state.session.outputs);

    let preSelectedInputDevice = useAppSelector((state) => state.session.preSelectedInputDevice);
    let preSelectedOutputDevices = useAppSelector((state) => state.session.preSelectedOutputDevices);

    const [currentDevice, setCurrentDevice] = useState<MediaDeviceInfo | null>(null);

    const dispatch = useAppDispatch();

    const [availableDevices, setAvailableDevices] = useState<MediaDeviceInfo[]>([]);
    useEffect(() => {
        getDevices(kind).then(devices => {
            setAvailableDevices(devices);
            dispatch(setInitialOutputDevicesAmount(devices.length));

            if (kind === 'audioinput' && !!preSelectedInputDevice) {
                // console.log('[1] LOAD [IN] DEVICE SELECTOR:', preSelectedInputDevice, devices);
                const haveDeviceToPreSelect = devices.find(d => d.deviceId === preSelectedInputDevice);
                // console.log('[2] found preSelected', !!haveDeviceToPreSelect);
                if (!!haveDeviceToPreSelect /*&& !!input?.device*/) {
                    setCurrentDevice(haveDeviceToPreSelect);
                    onDeviceSelected(haveDeviceToPreSelect);
                }
            }

            if (kind !== 'audioinput' && !!preSelectedOutputDevices && !!preSelectedOutputDevices[id]) {
                // console.log('[1] LOAD [OUT] DEVICE SELECTOR:', preSelectedOutputDevices, id, devices);
                const haveDeviceToPreSelect = devices.find(d => d.deviceId === preSelectedOutputDevices[id]);
                // const haveOutput = outputs.find(o => o.id === id);
                // console.log('[2] found preSelected', !!haveDeviceToPreSelect, !!haveOutput?.device);
                if (!!haveDeviceToPreSelect /*&& !!haveOutput?.device*/) {
                    setCurrentDevice(haveDeviceToPreSelect);
                    onDeviceSelected(haveDeviceToPreSelect);
                }
            }
        });

        navigator.mediaDevices.addEventListener('devicechange', event => {
            getDevices(kind).then(devices => {
                setAvailableDevices(devices);
                dispatch(setInitialOutputDevicesAmount(devices.length));
            });
        });
    }, [kind]);

    useEffect(() => {
        setCurrentDevice(null);
        onDeviceSelected(null);
    }, [onlyTextEnabled]);

    /*const getDevices = async (kind: MediaDeviceKind) => {
        await navigator.mediaDevices.getUserMedia({audio: true});
        let any = await navigator.mediaDevices.getSupportedConstraints();
        // console.log(any)
        return await navigator.mediaDevices
            .enumerateDevices()
            .then((devices) => {
                // console.log(devices)
                return devices.filter(d => kind === d.kind && d.deviceId !== 'default');
            })
            .catch((err) => {
                console.error(`${err.name}: ${err.message}`);
                return [];
            });
    }*/

    const usedDeviceIds = outputs.filter(o => o.device).map(o => o.device.deviceId);
    const startAdornmentIcon = onlyTextEnabled ? <VolumeOffIcon/> :
        (kind === 'audioinput' ? <MicIcon/> : <VolumeUpIcon/>);

    return (
        <Autocomplete
            id="selectableDevices"
            disabled={sessionStarted || onlyTextEnabled}
            // sx={{width: 300}}
            className={cn('device-selector', {'disable': onlyTextEnabled})}
            options={availableDevices.filter(d => !usedDeviceIds.includes(d.deviceId))}
            popupIcon={<ExpandMoreIcon/>}
            getOptionLabel={op => op.label}
            isOptionEqualToValue={(option, value) => {
                // console.log('option -> ', option.deviceId, value.deviceId)
                return option.deviceId === value.deviceId;
            }}
            value={currentDevice}
            onChange={(_e, selectedDevice) => {
                console.log('selectedDevice:', selectedDevice);
                setCurrentDevice(selectedDevice);
                onDeviceSelected(selectedDevice);
            }}

            renderInput={(params) =>
                <TextField
                    {...params}
                    size="small"
                    className="device-selector-label"
                    placeholder="Select a device"
                    InputProps={{
                        ...params.InputProps,
                        startAdornment: startAdornmentIcon
                    }}
                />
            }
        />
    );
}


type DeviceSelectorProps = {
    onDeviceSelected: (device: MediaDeviceInfo | null) => void,
    kind: MediaDeviceKind,
    onlyTextEnabled?: boolean,
    id: string
}

export default DeviceSelector;
